import { Wrapper } from './style';

// Component
import Container from 'components/common/Layout/Container';
import Image from 'next/image';
import Text from 'components/common/Text';

// Libs
import Translation from 'libs/Translation';

const ContactUs = ( { webConfig }) => {

    let items = [
        {id: 0, label: Translation.t('label.phone-number'), value: Translation.t('text.footer-phone-number')},
        {id: 1, label: Translation.t('label.email'), value: 'info@vclinic.io'},
        {id: 2, label: Translation.t('label.collaborate-offer'), value: 'job@vclinic.io'},
    ]
    
    if (webConfig.lang === 'fa') {
        items.push(
            {id: 3, label: Translation.t('label.address'), value: Translation.t('text.footer-address')}
        );
    }

    return (
        <Container>
            <Wrapper webConfig={webConfig}>
                <Text
                    tag="span"
                    className="title"
                >
                    {Translation.t('title.contact')}
                </Text>
                <div className='container'>
                    <Image
                        src="/nextasset/images/contact/laptop.svg"
                        width={349}
                        height={350}
                        alt="laptop"
                    />
                    <div className='text-section'>
                    {items.map(i => (
                        <div className='item text-section'>
                        <Text
                            tag="h2"
                            className="label"
                        >
                            {i.label}
                        </Text>
                        <Text
                            tag="h3"
                            className="value"
                        >
                            {i.value}
                        </Text>
                        </div>
                    ))}
                    </div>
                </div>
            </Wrapper>
        </Container>
      
    )
}

export default ContactUs;